import { api as com, apiFuns } from "sw-hic";
let { get, post, put, del } = apiFuns;

const api = {
  /** **********床位****************** **/
  Bed: {
    ...apiFuns.genStandard("bed", "api/ip", false, true),
    exchange: (id, tgtId) => apiFuns.put(`/api/ip/bed/${id}/exchange/${tgtId}`), // 交换床位
  },
  //添加床位
  addBed: (para) => {
    return post("/api/ip/bed", para);
  },
  // 修改床位
  editBed: (data, id) => {
    return put(`/api/ip/bed/${id}`, data);
  },
  // 删除床位
  delBed: (id) => {
    return del(`/api/ip/bed/${id}`);
  },
  //根据ID取得床位
  getBedById: (id) => {
    return get(`/api/ip/bed/${id}`);
  },
  //查询床位
  getBed: (data) => {
    return get(`/api/ip/bed`, data);
  },
  getAllBed: (data) => {
    return apiFuns.get(`/api/ip/bed/list`, data);
  },

  getRestNum: (data) => {
    return apiFuns.post(`/api/ip/bed/rest`, data);
  },
  //获取当前科室所有床位空位数
  getCounts: (deptCode) => {
    return apiFuns.get(`/api/ip/bed/${deptCode}/getRemainingSeats`);
  },

  // 清空床位
  cleanBed: (id) => {
    return apiFuns.put(`/api/ip/bed/assignment`, { bedId: id });
  },

  //获取包床
  cancelWrappe: (ipNo) => {
    return apiFuns.put(`/api/ip/bed/cancelWrappe/${ipNo}`);
  },
  /** *************床位记录(转科)标准CRUD接口*************** **/
  BedLog: apiFuns.genStandard("bedLog", "/api/ip"),
  //添加床位记录(转科)
  addBedLog: (para) => {
    return post("/api/ip/bedLog", para);
  },
  // 修改床位记录(转科)
  editBedLog: (id, data) => {
    return put(`/api/ip/bedLog/${id}`, data);
  },
  // 删除床位记录(转科)
  delBedLog: (id) => {
    return del(`/api/ip/bedLog/${id}`);
  },
  //根据ID取得床位记录(转科)
  getBedLogById: (id) => {
    return get(`/api/ip/bedLog/${id}`);
  },
  //查询床位记录(转科)
  getBedLog: (data) => {
    return get(`/api/ip/bedLog`, data);
  },
  //自定义转科
  changeKe(data) {
    return apiFuns.put(`/api/ip/bed/changeDeptCode`, data);
  },

  //查询空床位列表，可以包床。
  getEmptyList: (data) => {
    return apiFuns.get(`/api/ip/bed/emptyList`, data);
  },

  //通过患者的住院号获取所有包床信息。
  listByIpNo: (ipNo, ifShowHistory) => {
    // return get(`/api/ip/bedLog/listByIpNo/${ipNo}`);
    return apiFuns.get(`/api/ip/bedLog/${ipNo}/listByIpNo/${ifShowHistory}`);
  },
  //变更主床位
  changeMainBed: (id, changeId) => {
    return apiFuns.put(`/api/ip/bed/${id}/changeMainBed/${changeId}`);
  },

  //获取床位信息统计
  getCountsBed: (deptCode) => {
    return apiFuns.get(`/api/ip/bed/total/${deptCode}`);
  },
  //获取所有的收费项目
  getAllItems: (data) => {
    return apiFuns.get(`/api/md/feeStandard`, data);
  },

  // 获取一个床位的费用项目
  getBedFeeItems(bedLogId) {
    return apiFuns.get(`/api/ip/bedFee`, { bedLogId });
  },
  //取消一个床位的收费项目
  delBedFeeItem(id) {
    return apiFuns.del(`/api/ip/bedFee/${id}`);
  },
  //添加一个床位的收费项目
  addBedFeeItem(bedLogId, chargeCode) {
    return apiFuns.post("/api/ip/bedFee", { bedLogId, chargeCode });
  },

  // 通过床位记录id取消包床
  cancelWarpBed: (id) => {
    return apiFuns.put(`/api/ip/bedLog/${id}/cancelWrappe`);
  },
  //包床
  wrappedBed: (data) => {
    return apiFuns.post(`/api/ip/bedLog/wrappeAdd`, data);
    // return put(`/api/ip/bedLog/wrappeAdd`, data);
  },

  // /** **********主api中的接口****************** **/

  // // 根据证据号查询患者信息
  // getPatientByIdNo: com.getPatientByIdNo,
};

export default api;
